// extracted by mini-css-extract-plugin
export default {"dropdown":"_2lxQfQEes_XigDaHt-1C5f","menu":"_2BOXz2Fu1NtLucva8wWg7x"};